import { useQuery } from 'react-query';
import { useContext } from 'react';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { email_api } from '@axo/shared/data-access/api';
import { queryFunction } from '../../query-function.ts';
import {
  orttoCommunicationKeys,
  parseOrttoCommunicationKey,
} from '../../cache-keys/orttoCommunicationKeys.tsx';

export function useOrttoEmails(
  customerID: string | undefined,
  marketCountry: string | undefined
) {
  const { state } = useContext(DataAccessContext);
  const api = useAPI();
  const cacheKey = orttoCommunicationKeys.emails({
    customerID,
    marketCountry,
  });

  return useQuery(
    cacheKey,
    queryFunction(email_api.findOrttoEmails(api), ({ queryKey }) =>
      parseOrttoCommunicationKey(queryKey)
    ),
    {
      enabled:
        state.user.token.length > 0 &&
        customerID !== undefined &&
        marketCountry !== undefined,
    }
  );
}
